import { render, staticRenderFns } from "./concorsi.vue?vue&type=template&id=69d82318&"
import script from "./concorsi.vue?vue&type=script&lang=js&"
export * from "./concorsi.vue?vue&type=script&lang=js&"
import style0 from "./concorsi.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports